import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SocketRefetchState {
  value: number | null
}

const initialState: SocketRefetchState = {
  value: null,
}

const socketRefetchSlice = createSlice({
  name: 'socketRefetch',
  initialState,
  reducers: {
    setSocketRefetch(state, action: PayloadAction<number>) {
      state.value = action.payload
    },
  },
})

export const { setSocketRefetch } = socketRefetchSlice.actions
export default socketRefetchSlice.reducer
